const Footer = () => {
  return (
    <>
      <div className="flex-column-auto align-items-start d-flex justify-content-center">
        <div className="d-flex flex-row align-items-start">
          <a href="https://touchcast.com/terms" target="_blank">
            Terms of use
          </a>
          <span>•</span>
          <a href="https://touchcast.com/privacy" target="_blank">
            Privacy policy
          </a>
          <span>•</span>
          <div>{new Date().getFullYear().toString()} &copy; Touchcast</div>
        </div>
      </div>
      {/* <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          {new Date().getFullYear().toString()}&copy;
        </span>
        <a
          href='https://touchcast.com/'
          target='_blank'
          className='text-gray-800 text-hover-primary'
        >
          Powered by Touchcast
        </a>
      </div> */}
    </>
  );
};

export { Footer };
